<template>
  <f7-app :params="f7params" >

    <!-- Left panel with cover effect-->
    <f7-panel left cover theme-dark>
      <f7-view url="/panel-left/"></f7-view>
    </f7-panel>

    <!-- Your main view, should have "view-main" class -->
    <f7-view :pushState="true" main class="safe-areas" :url="$root.isLoggedIn ? '/' : '/login/'" id="main-view"></f7-view>
    

  </f7-app>
</template>
<script>

import routes from '../js/routes.js';

export default {
  data() {
    return {
      // Framework7 Parameters
      f7params: {
        name: 'AZConnect', // App name
        theme: 'auto', // Automatic theme detection
        // App root data
        data: function () {
        },
        // App routes
        routes: routes,
      }
    }
  },
  methods: {

  },
  mounted() {
    this.$f7ready((f7) => {

    });
  }
}
</script>